import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

interface MetadataDialogProps {
  open: boolean;
  onClose: () => void;
  environmentName: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Metadata structure varies by provider
  metadata: Record<string, any> | null;
}

/**
 * Dialog to explore environment metadata (objects, fields, etc.)
 */
export const MetadataDialog: React.FC<MetadataDialogProps> = ({
  open,
  onClose,
  environmentName,
  metadata,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Metadata Explorer - {environmentName}</DialogTitle>
      <DialogContent>
        {metadata ? (
          <TableContainer component={Paper} variant="outlined">
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Property</TableCell>
                  <TableCell>Value</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Object.entries(metadata).map(([key, value]) => (
                  <TableRow key={key}>
                    <TableCell sx={{ fontWeight: 600 }}>{key}</TableCell>
                    <TableCell>
                      {typeof value === 'object' ? JSON.stringify(value, null, 2) : String(value)}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <Typography color="text.secondary">
            No metadata available. Select an environment to view metadata.
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};
